// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryValueEntry.yaml
// Generated: 2026-03-11T13:04:50.952Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { InventoryValueEntry } from '@/types/inventory/InventoryValueEntry';

/**
 * InventoryValueEntry Service (Read-Only)
 * Query operations for InventoryValueEntry via the ABP API.
 */
export const inventoryValueEntryService = new ReadOnlyEntityService<InventoryValueEntry>(
  '/api/inventory/inventoryvalueentry',
  'InventoryValueEntry',
);
